module.exports = __webpack_public_path__ + "media/images/phone_mobile-5d143a16.svg";